// extracted by mini-css-extract-plugin
export default {"fixPt":"fixPt___gqWck","fixPb":"fixPb___eeCEv"};